import React from "react";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import "../../styles/pages/subpages/mini-markets_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";
import MiniMarketsPageImage from "../../assets/images/mini-market-page_image.png";
import MiniMarketImage from "../../assets/images/mini-market_image.png";

import PhoneIcon from "../../assets/icons/phone-icon.svg";
import AtIcon from "../../assets/icons/at-icon.svg";

const MiniMarketsPage = () => {
  return (
    <div className="mini-markets-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">
          Главная
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <a href="/stations" className="nav-link">
          Карта АЗС
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <span className="nav-link">Мини маркеты</span>
      </nav>

      <div className="mini-markets-page-content">
        <h2 className="gradient-page-title">Мини маркеты АЗС Bishkek Petroleum</h2>
        <img
          src={MiniMarketsPageImage}
          alt="Markets pic"
          className="mini-markets-image"
        />

        <div className="mini-markets-page-text-section">
          <div className="mini-markets-page-text-block">
            <h2 className="small-section-title">
              На АЗС Bishkek Petroleum, функционируют мини-маркеты с широким ассортиментом товаров необходимых в дороге.
            </h2>
            <div className="mini-markets-small-text-wrapper">
              <p className="mini-markets-text">
                Мини-маркеты созданы для максимального удовлетворения потребностей своих клиентов. Преобладающая часть нашего ассортимента сформирована на основе специфичных потребностей наших клиентов.
              </p>
              <p className="mini-markets-text">
                Основные категории товаров, предостовляемых на АЗС Bishkek Petroleum: Автохимия (Моторное масло, антифризы), Автокосметика (Полироли, Автошампуни), Аксессуары (Инструменты, коврики, стеклоочистители и т.д.), Автозапчасти (Маслянные фильтры и т.д.)
              </p>
            </div>
            <h2 className="small-section-title">
              Мини-маркеты "Bishkek Petroleum" - это удобное место для приобретения товаров как для автомобиля, так же для водителя и пассажиров. В наличии имеются продукты питания и напитки в упаковках удобных для употребления в пути.
            </h2>
          </div>
          <img src={MiniMarketImage} alt="Market pic" className="mini-market-image-block" />
        </div>

        <div className="mini-markets-sm-text-block">
          <span className="mini-markets-sm-text">Мы открыты для сотрудничества по реализации сопутствующих товаров и услуг.</span>
          <span className="mini-markets-sm-text">Если у вас есть предложения по сотрудничеству, мы будем рады их услышать:</span>
        </div>

        <div className="contact-block mini-markets-contact-block">
          <div className="contact-content">
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">тел.: <span className="number">0312 303 303</span> (доб. 1165, 1162)</span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">эл. адрес: <u className="email">osb@bpetroleum.kg</u></span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MiniMarketsPage;
